export const FEEDBACKS_PER_PAGE = 10;
export const ARTISTS_PER_PAGE = 8;

export const BASE_URL = 'https://sound-wave.b.goit.study/api';

export const API_ENDPOINTS = {
  GENRES: '/genres',
  ARTISTS: '/artists',
  ARTIST_BY_ID: '/artists/',
  FEEDBACKS: '/feedbacks',
};

